import {TeamDto} from '@team/model';

export interface TeamHeritage{
  team: TeamDto;
  childs: TeamHeritage[];
}
